// extracted by mini-css-extract-plugin
export default {"logos":"logoAnimation_logos__mELaY","logosSlideImg":"logoAnimation_logosSlideImg__yn3gA"};